export const bg = '#1e293b';
export const bgOffset = '#0f172a';
export const text = '#f8fafc';
export const textOffset = '#94a3b8';
export const border = '#334155';
export const primary = '#0ea5e9';
export const primaryOffset = '#0284c7';
export const secondary = '#fbbf24';
